import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import { AdminOrdersClient } from "@/components/admin/admin-orders-client";
import { AdminExpertWorkspace } from "@/components/admin/admin-expert-workspace";
import { PushPrivateThread } from "@/components/business-push/PushPrivateThread";
import { invokeEdgeFunction } from "@/lib/edge-functions";

const UUID_RE = /^[0-9a-f-]{36}$/i;

export function AdminHomeScreen() {
  return (
    <div>
      <h1 className="text-2xl font-black tracking-tight text-zinc-900">Admin</h1>
      <p className="mt-2 text-sm text-zinc-600">
        Order fulfillment and expert writeups. Access is restricted to emails listed in{" "}
        <code className="rounded bg-zinc-100 px-1">ADMIN_EMAILS</code>.
      </p>
      <ul className="mt-8 space-y-3 text-sm font-bold">
        <li>
          <Link to="/admin/orders" className="text-violet-700 underline-offset-2 hover:underline">
            Order management →
          </Link>
        </li>
      </ul>
    </div>
  );
}

export function AdminOrdersScreen() {
  return (
    <div>
      <Link to="/admin" className="text-sm font-bold text-violet-700 underline-offset-2 hover:underline">
        ← Admin home
      </Link>
      <h1 className="mt-4 text-2xl font-black tracking-tight text-zinc-900">Order management</h1>
      <p className="mt-2 max-w-2xl text-sm text-zinc-600">
        Expert rows show voice-memo progress. Business push orders have a private in-app thread — open the push workspace to reply
        async.
      </p>
      <div className="mt-8">
        <AdminOrdersClient />
      </div>
    </div>
  );
}

export function AdminExpertScreen() {
  const { orderId } = useParams<{ orderId: string }>();
  if (!orderId || !UUID_RE.test(orderId)) {
    return <p className="text-sm text-zinc-600">Not found.</p>;
  }
  return <AdminExpertWorkspace orderId={orderId} />;
}

export function AdminPushScreen() {
  const { orderId } = useParams<{ orderId: string }>();
  const [ctx, setCtx] = useState<{ orderId: string; lineSummary: string } | null>(null);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    if (!orderId || !UUID_RE.test(orderId)) {
      setGone(true);
      return;
    }
    void invokeEdgeFunction<{ orderId: string; lineSummary: string }>("admin-order-push-context", { orderId })
      .then((j) => setCtx(j))
      .catch(() => setGone(true));
  }, [orderId]);

  if (!orderId || !UUID_RE.test(orderId) || gone) {
    return <p className="text-sm text-zinc-600">Not found.</p>;
  }
  if (!ctx) {
    return <p className="text-sm text-zinc-600">Loading…</p>;
  }

  return (
    <div className="pb-4 pt-2">
      <PushPrivateThread
        orderId={ctx.orderId}
        viewer="admin"
        lineSummary={ctx.lineSummary}
        backHref="/admin/orders"
        backLabel="Orders"
      />
    </div>
  );
}
